<div class="update-info-dialog">
  <dynamic-form
    [apiName]="apiName"
    [label]="label"
    [group]="formGroup"
    [areaName]="areaName"
    [model]="model"
    [columns]="columns"
    required="true"
    (cancelChange)="cancel()"
    (submitChange)="save()"
    [saveLabel]="'ClientApp.Projects.FrameWorkShell.Header.UpdateWebApp.Update' | translate">
    <ng-container class="content">
      <div *ngIf="!UpdateInfo">
        {{ "ClientApp.Projects.FrameWorkShell.Header.UpdateWebApp.NothingShow" | translate }}
      </div>
      <div *ngFor="let item of UpdateInfo">
        <span>{{ item }}</span>
      </div>
    </ng-container>
  </dynamic-form>
</div>
